const onLoad = (cy: any) => {
  cy.elements().forEach(
    e => {
      const classes = e.data().classes;
      e.addClass(classes);
    });
};

export default onLoad;
